import React, { useRef } from 'react'
import { motion } from 'framer-motion'
//import Canvas from '../components/canvas/Canvas';
import img from './../assets/img/bespoke_image.jpg'
import { Container } from 'react-bootstrap'

function Test() {
  const ref =  useRef(null)
  return (
    <>
    <div className='py-5'
    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}
    ref={ref}
    >
      <img src={img} />
    </div>
   
      <motion.div
       initial={ { opacity: 0, y: 50 } }
       whileInView={{ opacity: 1, y:0, fontSize: '40px',transition: { delay: 0.5, duration: 0.5 } }}
       viewport={ { root: ref }}
      >
      I have some content here 
      </motion.div>   
    
      <Container>
      <p className="py-3 px-3" > This is going to be some awesome bit of coding to allow my website to become awesome and really excel in how we deliver some really cool and funky stuff and people will like it too</p>

      <h1>This is going to be awesome</h1>

      <p className="py-3 px-3" > This is going to be some awesome bit of coding to allow my website to become awesome and really excel in how we deliver some really cool and funky stuff and people will like it too</p>

      <p className="py-3 px-3" > This is going to be some awesome bit of coding to allow my website to become awesome and really excel in how we deliver some really cool and funky stuff and people will like it too</p>

      <p className="py-3 px-3" > This is going to be some awesome bit of coding to allow my website to become awesome and really excel in how we deliver some really cool and funky stuff and people will like it too</p>
<motion.p 
initial={ { opacity: 0 } }
whileInView={{ opacity: 1, transition: { delay: 0.5, duration: 0.5 } }}
viewport={ { once: true, amount: 1}}
className="py-3 px-3" > This is going to be some awesome bit of coding to allow my website to become awesome and really excel in how we deliver some really cool and funky stuff and people will like it too</motion.p>

      <motion.div
       initial={ { opacity: 0, y: 100 } }
       whileInView={{ opacity: 1, y: 0, fontSize: '40px',transition: { delay: 0.5, duration: 0.9 } }}
       viewport={ { once: true, amount: 1}}
      >
      I am a Freelance Web Designer
      </motion.div>   

      <p className="py-3 px-3" > This is going to be some awesome bit of coding to allow my website to become awesome and really excel in how we deliver some really cool and funky stuff and people will like it too</p>

<p className="py-3 px-3" > This is going to be some awesome bit of coding to allow my website to become awesome and really excel in how we deliver some really cool and funky stuff and people will like it too</p>

      </Container>
     
    </>
  )
}

export default Test